module.exports = __webpack_public_path__ + "static/media/blog.959d5753.svg";